<template>
  <div class="cashcoupon" :style="empty ? {'background': '#fff'} : {}">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list" v-if="list && list.length > 0">
        <ul>
          <li v-for="(item, index) of list" :key="index">
            <div>
              <p class="img">
                <img v-if="item.img_path" :src="item.img_path" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
                <span class="f11" style="color:#FFFFFF;">{{item.time}}发布</span>
              </p>
              <p class="f0">
                <span class="f14 over-ell-1" style="color: #292929;">{{item.content}}</span>
                <span class="f12" style="display: block;margin-top: 0.27rem;color: #FF0000" v-if="item.type == 2">{{item.reason}}</span>
                <span class="f12" style="display: block;margin-top: 0.27rem;color: #666666" v-else>{{item.reason}}</span>
              </p>
            </div>
            <b class="f16 flex-s" style="color: #FF1010" v-if="item.type == 2">-{{item.creditscore}}分</b>
            <b class="f16 flex-s" style="color: #333333" v-else>+{{item.creditscore}}分</b>
          </li>
        </ul>
      </div>
    </Scroller>

    <div v-if="empty" class="emptybox" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
      <empty v-if="empty" :path="'noData'"></empty>
    </div>
  </div>
</template>

<script>
  import empty from '../emptypage/empty'
  import Scroller from '../common/Scroller'
  import { isWeixin, fenxiang } from '../../assets/common/js/config'

  export default {
    name: 'creditscoreresume',
    components: {
      empty,
      Scroller
    },
    data () {
      return {
        list: [],
        listIndex: null,
        refresh: false,
        loading: false,
        finished: false,
        empty: false,
        nowPage: 0,
        noDataText: '',
        emptyHeight: 0,
      }
    },
    mounted: function () {
      this.emptyHeight = document.body.clientHeight
      if (isWeixin()) {
        fenxiang({path: 'creditscoreresume'})
      }
    },
    destroyed: function () {
      this.$toast.clear()
      this.$dialog.close()
    },
    methods: {
      getData: function () {
        var url = this.$ajax.getCreditscoreRecord_URL+'?pageno=' + this.nowPage + '&pagesize=' + this.pagesize
        var that = this
        that.$customRequestAjax(url).then(res => {
          if (res.data.code === 200) {
            if (that.nowPage === 1) {
              that.list = res.data.list
              that.refresh = false
            } else {
              that.list = that.list.concat(res.data.list)
            }
            that.loading = false
            if (that.list.length <= 0) {
              that.empty = true
            } else {
              that.empty = false
            }
            if (res.data.list.length < that.pagesize) {
              that.finished = true
            } else {
              that.finished = false
            }
          }
        })
      },
      onRefresh () {
        this.refresh = true
        this.nowPage = 1
        var that = this
        that.getData()
      },
      onInfinite () {
        this.loading = true
        this.finished = false
        var that = this
        that.nowPage++
        that.getData()
      }
    }
  }
</script>

<style scoped lang="scss">
  .cashcoupon {
    .list ul li {
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0.04rem;
      padding: 0.1rem;
      margin: 0.1rem 0.11rem;
      &:last-of-type {
        border-bottom-width: 0;
      }
      div {
        display: flex;
        align-items: center;
        .img {
          position: relative;
          span {
            display: block;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0;
            text-align: center;
            background: rgba(0, 0, 0, .45);
            border-radius: 0 0 0.04rem 0.04rem;
          }
        }
        img {
          width: 0.7rem;
          height: 0.7rem;
          border-radius: 0.04rem;
          object-fit: cover;
        }
        span {
          color: #333333;
          margin-left: 0.1rem;
        }
      }
      button {
        width: 0.64rem;
        height: 0.24rem;
        line-height: 0.24rem;
        text-align: center;
        outline: none;
        border: 0.01rem solid #AFB0AF;
        border-radius: 0.12rem;
        color: #999999;
        background: transparent;
        &.gz {
          border-color: #FC0324;
          color: #FC0324;
        }
      }
    }
  }
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/community/creditscoreresume.vue